<template>
    <div style="width: 100%;overflow-x: hidden">
        <Head></Head>
        <router-view></router-view>
        <Foot></Foot>
    </div>
</template>

<script>
    import Head from '../components/headerPage'
    import Foot from '../components/footerPage'
    import {getToken} from '@/api/token';
    export default {
        name: "indexPage",
        components: {
            Head,
            Foot
        },
        // created() {
        //     this.getT();
        //     setInterval(this.getT,30000);
        // },
        // methods: {
        //     getT() {
        //         localStorage.removeItem('X-Token')
        //         var params={
        //             timeStamp:40000
        //         }
        //         getToken(params).then((res)=>{
        //             localStorage.setItem('X-Token', res.data);
        //         })
        //     },
        // }
    }
</script>

<style scoped>

</style>